

import Vue from 'vue'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'
import AlertPlugin from 'vux/src/plugins/alert/index.js'

import FastClick from 'fastclick'
import App from './app'
import router from './router'
import store from './store'
import JsBridge from './tools/jsBridge'
import IconComponent from './icons'
import Raven from 'raven-js'
import RavenVue from 'raven-js/plugins/vue'
import DynamicCodeViewPlugin from './plugins/dynamicCodeView'
import GrantViewPlugin from './plugins/grantView'
import RealNameConfirmPlugin from './plugins/realNameConfirm'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import sa from 'sa-sdk-javascript'
import NoticeView from './plugins/noticeView'
import VueLazyLoad from 'vue-lazyload'
import AddressPickerPlugin from './plugins/addressPicker'
import BankPickerPlugin from './plugins/bankPicker'
import ContactPickerPlugin from './plugins/contactPicker'
import DatePickerPlugin from './plugins/datePicker'
import LocationHelper from './tools/locationHelper'






const windowHeight = window.innerHeight;
Vue.directive('fixedInput', function (el, binding) {
el.addEventListener('blur', function () {
let windowFocusHeight = window.innerHeight;
if (windowHeight === windowFocusHeight) {
return;
}
let currentPosition;
let speed = 1; 
currentPosition = document.documentElement.scrollTop || document.body.scrollTop;
currentPosition -= speed;
window.scrollTo(0, currentPosition); 
currentPosition += speed; 
window.scrollTo(0, currentPosition); 
});
});
Vue.component(IconComponent.name, IconComponent)
let HOST = process.env.HOST;
HOST = HOST === 'pro' ? 'production' : 'default';
sa.init({
heatmap: {},
server_url: 'https://sensors-api.xycredit.com.cn/sa?project=' + HOST


})
sa.quick('autoTrack')
sa.register({
'app_name': '享宇钱包'
})

FastClick.attach(document.body)

if (process.env === 'production') {
Raven
.config('https://97528cc52254454f9eb19d0dfa543075@sentry.io/165133')
.addPlugin(RavenVue, Vue)
.install()
}

Vue.use(ConfirmPlugin)
Vue.use(ToastPlugin)
Vue.use(LoadingPlugin)
Vue.use(AlertPlugin)
Vue.use(DynamicCodeViewPlugin)
Vue.use(GrantViewPlugin)
Vue.use(RealNameConfirmPlugin)
Vue.use(VueAwesomeSwiper)
Vue.use(NoticeView)
Vue.use(VueLazyLoad)
Vue.use(AddressPickerPlugin)
Vue.use(BankPickerPlugin)
Vue.use(ContactPickerPlugin)
Vue.use(DatePickerPlugin)


global.isOrangeStyle = false

Vue.prototype.$toast = {
show(text, time) {
if (!time) {
time = 2000
}
Vue.$vux.toast.show({
width: 'auto',
type: 'text',
time: time,
position: 'middle',
text
})
}
}

Vue.prototype.$loading = {
show(text) {
Vue.$vux.loading.show({
text
})
},
hide() {
Vue.$vux.loading.hide()
}
}

Vue.prototype.$alert = {
show(text) {
Vue.$vux.alert.show({
title: '提示',
content: text
})
}
}
LocationHelper.startLocation()
router.beforeEach(function (to, from, next) {
store.dispatch('updateLoadingStatus', true)
next()
})

router.afterEach(router => {
if (router.name === 'UserCenter' || router.name === 'LoanProduct' || router.name === 'welfare' || router.name === 'signIn') {
store.dispatch('switchTabbarShow', true)
} else {
store.dispatch('switchTabbarShow', false)
}
window.setTimeout(function () {
store.dispatch('updateLoadingStatus', false)
}, 1)
})


window.backToPrevUI = function () {
if (window.location.href.search(/productDetail/) !== -1) {
if (window.localStorage.getItem('productDetailFromRouterName') === 'LoanProduct') {
router.push({'name': 'LoanProduct'})
} else if (window.localStorage.getItem('productDetailFromRouterName') === 'ZlProductList') {
router.push({'name': 'ZlProductList'})
} else {
router.back()
}
} else if (window.location.href.search(/zlProductList/) !== -1) {
router.push({'name': 'LoanProduct'})
} else if (window.location.href.search(/myLoan/) !== -1) {
router.push({'name': 'UserCenter'})
} else if (window.location.href.search(/insurance/) !== -1) {
router.push({'name': 'LoanProduct'})
} else if (window.location.href.search(/loanProduct/) !== -1) {
if (window.android && window.android.Exit()) {
window.android.Exit()
}
} else if (window.location.href.search(/userCenter/) !== -1) {
router.push({'name': 'LoanProduct'})
} else if (window.location.href.search(/dotStep1/) !== -1) {
let productDetailInfo = window.localStorage.getItem('ProductDetailInfo')
router.push({name: 'ProductDetail', params: {productInfo: productDetailInfo}})
} else if (window.location.href.search(/dotApplying/) !== -1) {
let productDetailInfo = window.localStorage.getItem('ProductDetailInfo')
router.push({name: 'ProductDetail', params: {productInfo: productDetailInfo}})
} else {
window.history.back()
}
}

/* eslint-disable no-new */
new Vue({
el: '#app',
router,
store,
template: '<App/>',
components: {App}
})



// WEBPACK FOOTER //
// ./src/main.js